import { render, staticRenderFns } from "./ednImage.vue?vue&type=template&id=64e3e804"
import script from "./ednImage.vue?vue&type=script&lang=js"
export * from "./ednImage.vue?vue&type=script&lang=js"
import style0 from "./ednImage.vue?vue&type=style&index=0&id=64e3e804&prod&lang=scss"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports